import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-adcafdec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sla" }
const _hoisted_2 = { class: "flex items-center justify-between mt-3" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-1" }, null, -1))
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = {
  key: 0,
  class: "title__direction"
}
const _hoisted_7 = {
  key: 3,
  class: "title__direction"
}
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sla_actions = _resolveComponent("sla-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_sla_filters = _resolveComponent("sla-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_sla_actions, {
          key: 0,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          "initial-value": _ctx.actions_state.initial_value,
          onCreate: _ctx.createSLA,
          onUpdate: _ctx.updateSLA,
          onDelete: _ctx.deleteSLA,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false))
        }, null, 8, ["loading", "is-create", "is-update", "is-delete", "initial-value", "onCreate", "onUpdate", "onDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "SLA клиента LTL" }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.exportExcel,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Скачать в Excel ")
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_the_button, {
            class: "primary small",
            onClick: _ctx.startCreate
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить SLA ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.havePermissions(['location.sla-import', 'all-root-permission']))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/sla-import"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_the_button, { class: "primary small" }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createTextVNode(" Импортировать ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_sla_filters, {
        class: "mt-6",
        loading: _ctx.state.is_loading,
        onSearch: _ctx.applyFilters,
        onReset: _ctx.resetFilters
      }, null, 8, ["loading", "onSearch", "onReset"]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 0,
              loading: _ctx.state.is_loading,
              text: "При получении списка SLA произошла ошибка",
              "error-message": _ctx.state.failure.error_state.message,
              "error-url": _ctx.state.failure.error_state.url,
              "error-status": _ctx.state.failure.error_state.status,
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadSLA(_ctx.state.pagination.current_page)))
            }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
          : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
              key: 1,
              loading: _ctx.state.is_loading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_table, {
                  loading: _ctx.state.is_loading,
                  columns: _ctx.SLAColumns,
                  rows: _ctx.state.list,
                  "with-limit": "",
                  "pagination-limit": _ctx.filters_state.limit,
                  "pagination-total-items": _ctx.state.pagination.total_items,
                  "pagination-current-page": _ctx.state.pagination.current_page,
                  "pagination-total-pages": _ctx.state.pagination.total_pages,
                  onChangePage: _ctx.loadSLA,
                  onChangeLimit: _ctx.onLimitChange
                }, {
                  td: _withCtx(({ column, row }) => [
                    (column.key === 'direction')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.fromCity) + " - " + _toDisplayString(row.toCity), 1))
                      : (column.key === 'type')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(row.company ? 'Уникальный' : 'Стандартный'), 1)
                          ], 64))
                        : (column.key === 'company')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(row.company ? row.company.shortName : '-'), 1)
                            ], 64))
                          : (column.key === 'periodId')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.periodId === 1 ? 'Летний' : 'Зимний'), 1))
                            : (column.key === 'is_active')
                              ? (_openBlock(), _createBlock(_component_cheap, {
                                  key: 4,
                                  class: _normalizeClass(['small green', { red: !row.isActive }])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.isActive ? 'Активен' : 'Не активен'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                ], 64))
                  ]),
                  actions: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_the_button, {
                        hint: "Редактировать",
                        class: "primary extra-small",
                        loading: _ctx.state.is_loading,
                        onClick: ($event: any) => (_ctx.startUpdate(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["loading", "onClick"]),
                      _createVNode(_component_the_button, {
                        hint: "Удалить",
                        class: "red extra-small ml-3",
                        loading: _ctx.state.is_loading,
                        onClick: ($event: any) => (_ctx.startDelete(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 2
                      }, 1032, ["loading", "onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ])
  ], 64))
}